import styled, { css } from 'styled-components';

export const LoaderContainer = styled.div<{ color?: string }>`
  ${({ color = '#FFFFFF' }) => css`
    > div {
      margin: 0 auto;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      border: 4px solid ${color};
      border-top: 4px solid rgba(0, 0, 0, 0);
      -webkit-animation: spin 1.25s linear infinite;
      animation: spin 1.25s linear infinite;
    }

    /* Safari */
    @-webkit-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `}
`;
